"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Fade = _interopRequireDefault(require("./Fade"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const BG = _styledComponents.default.div.withConfig({
  displayName: "Backdrop__BG",
  componentId: "sc-1rj928r-0"
})(["background:rgba(0,0,0,0.2);bottom:0;left:0;position:fixed;right:0;top:0;z-index:1;"]);

const Backdrop = ({
  className,
  show,
  target,
  ...rest
}) => {
  const el = /*#__PURE__*/_react.default.createElement("div", _extends({
    className: className
  }, rest), /*#__PURE__*/_react.default.createElement(_Fade.default, {
    in: show
  }, /*#__PURE__*/_react.default.createElement(BG, null)));

  if (target === 'body') {
    return /*#__PURE__*/_reactDom.default.createPortal(el, document.body);
  }

  return el;
};

var _default = (0, _styledComponents.default)(Backdrop).withConfig({
  displayName: "Backdrop",
  componentId: "sc-1rj928r-1"
})([""]);

exports.default = _default;